import docCookies from 'doc-cookies';
import { xsfrToken, locale } from './alpine-functions';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';

import Accordion from './components/accordion';
import AsyncForm from './components/async-form';
import BrochurePopup from './components/brochure-popup';
import Carousel from './components/carousel';
import Dropdown from './components/dropdown';
import DropdownRange from './components/dropdown-range';
import Filter from './components/filter';
import Modal from './components/modal';
import NavbarMenu from './components/navbar-menu';
import RealEstateMap from './components/real-estate-map';
import RealEstates from './components/real-estates';
import Slider from './components/slider';
import TextareaAutoheight from './components/textarea-autoheight';

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(intersect);

Alpine.data('accordion', Accordion);
Alpine.data('asyncForm', AsyncForm);
Alpine.data('brochurePopup', BrochurePopup);
Alpine.data('carousel', Carousel);
Alpine.data('dropdown', Dropdown);
Alpine.data('dropdownRange', DropdownRange);
Alpine.data('filter', Filter);
Alpine.data('modal', Modal);
Alpine.data('navbarMenu', NavbarMenu);
Alpine.data('realEstateMap', RealEstateMap);
Alpine.data('realEstates', RealEstates);
Alpine.data('slider', Slider);
Alpine.data('textareaAutoheight', TextareaAutoheight);

Alpine.store('currency', {
  active: null,
  rates: [],
  activeCurrencyEl: document.getElementById('active-currency'),

  init() {
    if (this.activeCurrencyEl) {
      this.active = this.activeCurrencyEl.dataset.currency;
      this.rates = JSON.parse(this.activeCurrencyEl.dataset.rates);
    }
  },

  async change(activeCurrency) {
    this.active = activeCurrency;
    await xsfrToken();

    fetch('/set-currency', {
      body: JSON.stringify({ currency: activeCurrency }),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
      },
      method: 'POST',
    })
      .then((response) => response.json())
      .then((data) => {
        this.activeCurrencyEl.dataset.currency = data.currency;
        this.activeCurrencyEl.dataset.rates = data.rates;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  },

  formatPrice(priceInEuro, from = false) {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: this.active,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    const translations = { cs: 'od', sk: 'od', en: 'from' };
    const fromText = from ? translations[locale] : '';

    let price = priceInEuro;
    let priceCZK;
    let rate;

    Object.values(this.rates).filter((currency) => {
      if (currency[3] === 'EUR') {
        rate = parseFloat(currency[4].replace(',', '.'));
        priceCZK = priceInEuro * rate;
      }
    });

    if (this.active === 'CZK') {
      price = priceCZK;
    }

    if (this.active === 'USD') {
      Object.values(this.rates).filter((currency) => {
        if (currency[3] === 'USD') {
          rate = parseFloat(currency[4].replace(',', '.'));
        }
      });
      price = priceCZK / rate;
    }

    if (this.active === 'PLN') {
      Object.values(this.rates).filter((currency) => {
        if (currency[3] === 'PLN') {
          rate = parseFloat(currency[4].replace(',', '.'));
        }
      });
      price = priceCZK / rate;
    }

    if (this.active === 'GBP') {
      Object.values(this.rates).filter((currency) => {
        if (currency[3] === 'GBP') {
          rate = parseFloat(currency[4].replace(',', '.'));
        }
      });
      price = priceCZK / rate;
    }

    if (this.active === 'AED') {
      Object.values(this.rates).filter((currency) => {
        if (currency[3] === 'AED') {
          price = priceInEuro * currency[4];
        }
      });
    }

    return (
      (fromText ? `<small>${fromText}</small>&nbsp;` : '') +
      formatter.format(price)
    );
  },
});

Alpine.store('filter', {
  options: {},
  init() {},

  get filtering() {
    return Object.keys(this.options).length > 0;
  },

  get showClearFilter() {
    const requiredKeys = [
      'gps_latitude:gte',
      'gps_latitude:lte',
      'gps_longitude:gte',
      'gps_longitude:lte',
    ];
    const objKeys = Object.keys(this.options);

    if (objKeys.length !== requiredKeys.length) {
      return Object.keys(this.options).length > 0;
    }
    return !objKeys.every((key) => requiredKeys.includes(key));
  },

  set(filter) {
    if (filter.values === '') {
      delete this.options[filter.filter];
    } else {
      if (Array.isArray(filter.values)) {
        this.options[filter.filter] = filter.values.map((value) =>
          JSON.parse(value)
        );
      } else {
        try {
          const data = JSON.parse(filter.values);
          this.options[filter.filter] =
            typeof data === 'object' ? [data] : [{ text: data, value: data }];
        } catch (error) {
          this.options[filter.filter] = [
            { text: filter.values, value: filter.values },
          ];
        }
      }
    }
    if (this.options[filter.filter] && !this.options[filter.filter].length) {
      delete this.options[filter.filter];
    }
  },

  filterText(filterName) {
    if (this.options[filterName]) {
      let ret = '';
      this.options[filterName].forEach((item, index) => {
        let title = item.text;
        ret += '<span>';
        ret += title.length > 14 ? title.substring(0, 15) + '...' : title;
        index < this.options[filterName].length - 1 ? (ret += ', ') : '';
        ret += '</span>';
      });
      return ret;
    }
  },

  reset() {
    this.options = {};
    window.dispatchEvent(
      new CustomEvent('reset', {
        bubbles: true,
        cancelable: true,
      })
    );
  },
});

Alpine.start();
